<template>
  <div style="margin-left: auto" v-if="status.no_data">
    <span>Прогресс: {{ status.all - status.no_data }}/{{status.all}}</span>
    <div class="progressbar">
      <span :style="{width: (status.all-status.no_data)/status.all*100 +'%'}"></span>
    </div>
  </div>

</template>

<script>


import {DictionaryApi} from "@/api/dictionary";

export default {
  name: 'ReviewStatus',
  props: {
    all: {type: Object},
    no_data: {type: Object},
  },
  data() {
    return {
      name: 'reviews_monitor',
      status: {all: this.all, no_data: this.no_data}
    }
  },

  watch: {
    no_data(val){
      this.status.no_data = this.no_data
    },
    "status.no_data"(val){
      if (val){
        this.startTimer()
      }
      else{
        this.stopTimer();
      }
    }
  },

  mounted: function () {
    // this.getStatus()
    this.startTimer()
  },
  computed: {},

  methods: {
     stopTimer() {
      clearTimeout(this.timer)
    },
    startTimer() {
      this.timer = setInterval(() => {
        this.getStatus()
      }, 10000)
    },
    getStatus() {
      DictionaryApi.current_status(this.name).then(response => {
        this.status = response
      })
    }

  }
}

</script>
<style scoped lang="scss">
.progressbar {
  height: 14px;
  position: relative;
  background: #fff;
  padding: 0;
  box-shadow: inset 0 -1px 1px rgba(255, 255, 255, 0.3);
  border-radius: 5px;
  border: 1px solid #ccc;
  width: 250px;

  span {
    display: block;
    height: 100%;
    background-color: rgb(135, 206, 250);
    background-image: linear-gradient(center bottom, rgb(135, 206, 250) 37%, rgb(135, 206, 250) 69%);
    box-shadow: inset 0 2px 9px rgba(255, 255, 255, 0.3),
    inset 0 -2px 6px rgba(0, 0, 0, 0.4);
    position: relative;
    overflow: hidden;
  }
}

</style>

